// src/reducers/patientProfileReducer.js

import {
  PATIENT_PROFILE_CREATED,
  GET_ALL_PATIENT_PROFILES,
  GET_ONE_PATIENT_PROFILE,
  PATIENT_PROFILE_UPDATED,
  PATIENT_PROFILE_DELETED,
  GET_ALL_PATIENT_PROFILES_SUCCESS,
  GET_ALL_PATIENT_PROFILES_FAIL,
} from '../actions/types';

const initialState = {
  profiles: [],        // All profiles (used by GET_ALL_PATIENT_PROFILES)
  profile: {},         // Single profile for view/edit
  patientList: [],     // Patient list for admin UI
  loading: true,
};


const patientProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    // 🔹 After creating a profile, add to list
    case PATIENT_PROFILE_CREATED:
      return {
        ...state,
        profiles: [...state.profiles, action.payload],
        loading: false,
      };

    // 🔹 Get all profiles
    case GET_ALL_PATIENT_PROFILES:
      return {
        ...state,
        profiles: Array.isArray(action.payload) ? action.payload : [],
        loading: false,
      };

    // 🔹 Get one profile (for view/edit)
    case GET_ONE_PATIENT_PROFILE:
      return {
        ...state,
        profile: action.payload || null,
        loading: false,
      };

    // 🔹 Update a profile
    case PATIENT_PROFILE_UPDATED:
      return {
        ...state,
        profiles: state.profiles.map((p) =>
          p.id === action.payload.id ? action.payload : p
        ),
        profile:
          state.profile && state.profile.id === action.payload.id
            ? action.payload
            : state.profile,
        loading: false,
      };

    // 🔹 Delete a profile
    case PATIENT_PROFILE_DELETED:
      return {
        ...state,
        profiles: state.profiles.filter((p) => p.id !== action.payload),
        loading: false,
      };
      case GET_ALL_PATIENT_PROFILES_SUCCESS:
  return {
    ...state,
    profiles: action.payload,
    loading: false,
  };

case GET_ALL_PATIENT_PROFILES_FAIL:
  return {
    ...state,
    profiles: [],
    loading: false,
  };



    // 🔸 Default: return current state
    default:
      return state;
  }
};

export default patientProfileReducer;
